var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrump',{attrs:{"breadcrump":_vm.breadcrump}}),_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v("Lista ofert sprzedaży monet")]),_c('pricing-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }